// extracted by mini-css-extract-plugin
export default {"App":"App_App__y-jd3","main":"App_main__cb6xK"};